import type { TestSection } from "@/lib/testTypes";

export function getSchoolYear(): string {
  const now = new Date();
  const month = now.getMonth();
  const year = now.getFullYear();

  if (month >= 8) {
    return `${year} / ${year + 1}`;
  }

  return `${year - 1} / ${year}`;
}

export function getDuration(testType?: string | null, explicitDuration?: string | null): string {
  if (explicitDuration && explicitDuration.trim()) {
    return explicitDuration.trim();
  }

  const type = testType?.toLowerCase() ?? "";

  if (type.includes("quiz") || type.includes("quizz")) return "30 min";
  if (type.includes("global") || type.includes("gb") || type.includes("semester")) return "1 hour";
  if (type.includes("unit") || type.includes("sequence")) return "45 min";

  return "1 hour";
}

export function getTotalPoints(sections: TestSection[]): number {
  return sections.reduce((sum, section) => sum + section.totalPoints, 0);
}
